import * as React from "react";
import { AsyncActionStatus } from "../../shared/abstractStore";
import { useAsyncCallback } from "react-use-async-callback";
import { useAccountService } from "./useAccountService";

/**
 * Callback to reset the password of an account using a unique URL from an email as authorization.
 */
export function useResetPasswordCallback(): [(password: string) => Promise<boolean>, AsyncActionStatus] {
    const accountService = useAccountService();

    // Get the code from the query string.
    const { userId, code } = React.useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const userId = params.get('userId') ?? params.get('UserId') ?? '';
        const code = params.get('code') ?? params.get('Code') ?? '';
        return { userId, code };
    }, []);

    const [action, { isExecuting, errors }] = useAsyncCallback(async (password: string) => {
        return await accountService.resetPassword({ userId: userId, code: code, password: password  });
    }, [accountService]);

    return [action, { isExecuting, errors }];
}
